<template>
    <main>
        <router-view />
    </main>
</template>
<script>
const debug = false
const pxSize = true

if (debug) {
    setInterval(() => {
        document.querySelectorAll('*').forEach(el => {
            if (!hasDirectText(el)) {
                el.classList.remove('font-size-debug')
                return
            }

            const size = parseInt(getComputedStyle(el).fontSize, 10)
            const lineHeight = parseInt(getComputedStyle(el).lineHeight, 10)

            const remSize = pxSize ? size : size / 16
            const emHeight = Math.round((lineHeight / size) * 10) / 10
            el.classList.add('font-size-debug')
            el.setAttribute('data-font-size', `${remSize} ${pxSize ? 'px' : 'em'}, ${emHeight}`)
        })
    }, 5000)
}

function hasDirectText(el) {
    return Array.from(el.childNodes).some(
        node => node.nodeType === Node.TEXT_NODE && node.textContent.trim().length > 0,
    )
}
</script>
<style>
.font-size-debug {
    position: relative;
    border: 1px solid #0af9;
    border-radius: 4px;
}

.font-size-debug::after {
    content: attr(data-font-size);
    position: absolute;
    top: 0;
    right: 0;
    background: #8dd9ffd4;
    color: #000;
    line-height: 1em;
    border-top-right-radius: 4px;
    border-bottom-left-radius: 4px;
    padding: 2px 3px;
    pointer-events: none;
    font-weight: bold;
    font-size: 11px;
    font-family: theme('fontFamily.text');
}
</style>
